import { Navigate, useLocation } from "react-router"
import { useAuth } from "./use-auth"
import EnkLoader from "../components/common/loader"

export default function EnkProtectedRoute({ children }: { children: JSX.Element }) {
  const auth = useAuth()
  const location = useLocation()
  const fromUrl = location.pathname + location.search + location.hash

  if (auth.loading) {
    return <EnkLoader />
  }

  if (!auth.user) {
    console.log("User not logged in, redirecting to login page. Current URL:", fromUrl)
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ fromUrl }} replace />
  }

  return children
}
